import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export function formatNumber(d) {
	if (d === null) {
		return 0;
	}
	if (isNaN(d)) {
		return 0;
	}

	if (d > 999) {
		let i;
		for (i = 0; d >= 1000; i++) {
			d /= 1000;
		}
		return d.toFixed(1) + ['', ' k', ' m', ' g'][i];
	}
	return d;
}

export function TextParser(text) {
	if (!text) {
		return;
	}

	// Split the text by line breaks
	const lines = text.split('<br>').filter((line) => line.trim() !== '');
	if (lines.length == 0) {
		return <>{text}</>;
	}

	return (
		<>
			{lines.map((line, index) => {
				// Check for strong tag and render accordingly
				if (line.trim().startsWith('<strong>') && line.trim().endsWith('</strong>')) {
					return (
						<strong key={index}>
							{line.replace('<strong>', '').replace('</strong>', '')} <br></br>
						</strong>
					);
				}

				// Check for combinations of bold and underline tags and render accordingly
				const boldUnderlinePatterns = [
					{ open: '<b><u>', close: '</u></b>' },
					{ open: '<u><b>', close: '</b></u>' },
					{ open: '<b><u>', close: '</b></u>' }, // New pattern
					{ open: '<u><b>', close: '</u></b>' } // New pattern
				];

				const matchingPattern = boldUnderlinePatterns.find(
					(pattern) => line.includes(pattern.open) && line.includes(pattern.close)
				);

				if (matchingPattern) {
					const parts = line.split(
						new RegExp(`${matchingPattern.open}|${matchingPattern.close}`, 'g')
					);
					return (
						<span key={index}>
							{parts.map((part, partIndex) => {
								if (partIndex === 1) {
									return (
										<span
											key={partIndex}
											style={{ fontWeight: 'bold', textDecoration: 'underline' }}
										>
											{part}
										</span>
									);
								}
								return part;
							})}
						</span>
					);
				}

				// Otherwise, treat as a normal line and wrap in a paragraph
				return (
					<span key={index}>
						{line}
						<br></br>
					</span>
				);
			})}
		</>
	);
}

export function formatString(s) {
	try {
		const cleanHtml = DOMPurify.sanitize(s, { USE_PROFILES: { html: true } });

		return parse(cleanHtml);
	} catch (err) {
		return s;
	}
}

export function parseSubscriptionList(s) {
	if (s.includes('check')) {
		s = s.replace('check', '');
	}

	if (s.includes('cancel')) {
		s = s.replace('cancel', '');
	}
	return s;
}

export const textTruncate = function (str, length, ending) {
	if (length == null) {
		length = 100;
	}
	if (ending == null) {
		ending = '...';
	}
	if (str?.length > length) {
		return str.substring(0, length - ending.length) + ending;
	} else {
		return str;
	}
};
